/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfInternalUserAdminEventResponseV3, InternalUserAdminEventResponseV3FromJSONTyped, InternalUserAdminEventResponseV3ToJSON, } from './InternalUserAdminEventResponseV3';
import { instanceOfInternalUserCompanyResponseV3, InternalUserCompanyResponseV3FromJSONTyped, InternalUserCompanyResponseV3ToJSON, } from './InternalUserCompanyResponseV3';
import { instanceOfInternalUserForumDiscussionResponseV3, InternalUserForumDiscussionResponseV3FromJSONTyped, InternalUserForumDiscussionResponseV3ToJSON, } from './InternalUserForumDiscussionResponseV3';
import { instanceOfInternalUserMediaCenterFileResponseV3, InternalUserMediaCenterFileResponseV3FromJSONTyped, InternalUserMediaCenterFileResponseV3ToJSON, } from './InternalUserMediaCenterFileResponseV3';
import { instanceOfInternalUserMediaCenterFolderResponseV3, InternalUserMediaCenterFolderResponseV3FromJSONTyped, InternalUserMediaCenterFolderResponseV3ToJSON, } from './InternalUserMediaCenterFolderResponseV3';
import { instanceOfInternalUserNewsResponseV3, InternalUserNewsResponseV3FromJSONTyped, InternalUserNewsResponseV3ToJSON, } from './InternalUserNewsResponseV3';
import { instanceOfInternalUserOpportunityResponseV3, InternalUserOpportunityResponseV3FromJSONTyped, InternalUserOpportunityResponseV3ToJSON, } from './InternalUserOpportunityResponseV3';
import { instanceOfInternalUserPostResponseV3, InternalUserPostResponseV3FromJSONTyped, InternalUserPostResponseV3ToJSON, } from './InternalUserPostResponseV3';
import { instanceOfInternalUserProjectResponseV3, InternalUserProjectResponseV3FromJSONTyped, InternalUserProjectResponseV3ToJSON, } from './InternalUserProjectResponseV3';
import { instanceOfInternalUserUserEventResponseV3, InternalUserUserEventResponseV3FromJSONTyped, InternalUserUserEventResponseV3ToJSON, } from './InternalUserUserEventResponseV3';
export function InternalUserContentRecommendationResponseCollectionV3AllOfDataFromJSON(json) {
    return InternalUserContentRecommendationResponseCollectionV3AllOfDataFromJSONTyped(json, false);
}
export function InternalUserContentRecommendationResponseCollectionV3AllOfDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfInternalUserAdminEventResponseV3(json)) {
        return InternalUserAdminEventResponseV3FromJSONTyped(json, true);
    }
    if (instanceOfInternalUserCompanyResponseV3(json)) {
        return InternalUserCompanyResponseV3FromJSONTyped(json, true);
    }
    if (instanceOfInternalUserForumDiscussionResponseV3(json)) {
        return InternalUserForumDiscussionResponseV3FromJSONTyped(json, true);
    }
    if (instanceOfInternalUserMediaCenterFileResponseV3(json)) {
        return InternalUserMediaCenterFileResponseV3FromJSONTyped(json, true);
    }
    if (instanceOfInternalUserMediaCenterFolderResponseV3(json)) {
        return InternalUserMediaCenterFolderResponseV3FromJSONTyped(json, true);
    }
    if (instanceOfInternalUserNewsResponseV3(json)) {
        return InternalUserNewsResponseV3FromJSONTyped(json, true);
    }
    if (instanceOfInternalUserOpportunityResponseV3(json)) {
        return InternalUserOpportunityResponseV3FromJSONTyped(json, true);
    }
    if (instanceOfInternalUserPostResponseV3(json)) {
        return InternalUserPostResponseV3FromJSONTyped(json, true);
    }
    if (instanceOfInternalUserProjectResponseV3(json)) {
        return InternalUserProjectResponseV3FromJSONTyped(json, true);
    }
    if (instanceOfInternalUserUserEventResponseV3(json)) {
        return InternalUserUserEventResponseV3FromJSONTyped(json, true);
    }
    return {};
}
export function InternalUserContentRecommendationResponseCollectionV3AllOfDataToJSON(json) {
    return InternalUserContentRecommendationResponseCollectionV3AllOfDataToJSONTyped(json, false);
}
export function InternalUserContentRecommendationResponseCollectionV3AllOfDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfInternalUserAdminEventResponseV3(value)) {
        return InternalUserAdminEventResponseV3ToJSON(value);
    }
    if (instanceOfInternalUserCompanyResponseV3(value)) {
        return InternalUserCompanyResponseV3ToJSON(value);
    }
    if (instanceOfInternalUserForumDiscussionResponseV3(value)) {
        return InternalUserForumDiscussionResponseV3ToJSON(value);
    }
    if (instanceOfInternalUserMediaCenterFileResponseV3(value)) {
        return InternalUserMediaCenterFileResponseV3ToJSON(value);
    }
    if (instanceOfInternalUserMediaCenterFolderResponseV3(value)) {
        return InternalUserMediaCenterFolderResponseV3ToJSON(value);
    }
    if (instanceOfInternalUserNewsResponseV3(value)) {
        return InternalUserNewsResponseV3ToJSON(value);
    }
    if (instanceOfInternalUserOpportunityResponseV3(value)) {
        return InternalUserOpportunityResponseV3ToJSON(value);
    }
    if (instanceOfInternalUserPostResponseV3(value)) {
        return InternalUserPostResponseV3ToJSON(value);
    }
    if (instanceOfInternalUserProjectResponseV3(value)) {
        return InternalUserProjectResponseV3ToJSON(value);
    }
    if (instanceOfInternalUserUserEventResponseV3(value)) {
        return InternalUserUserEventResponseV3ToJSON(value);
    }
    return {};
}
